<template>
    <footer class="pt-0">
        <div class="container-fluid footer-bg">
            <div class="container footer-content py-4">
                <div class="row">
                    <div class="col-md-12 col-lg-4 widget-1">
                      <div class="row">
                        <div class="col-12 col-sm-6 col-lg-12 mb-2">
                          <img class="mr-0" alt="Company logo" src="@/assets/images/spectrum_logo_vector_white.png">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 col-12 widget-2">
                      <h4>Contact us</h4>
                      <ul class="list-unstyled">
                        <li>Spectrum Digital Labels Ltd</li>
                        <li>Unit D1 &amp; D2 Neaton Business Park</li>
                        <li>Norwich road, Watton</li>
                        <li>Norfolk</li>
                        <li>IP25 6JB</li>
                      </ul>
                      <p>Tel: <a href="tel:+441953661644">01953 661644</a></p>
                      <a class="w-100 d-block" href="mailto:sales@spectrumdigitallabels.com">sales@spectrumdigitallabels.com</a>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12 widget-3">
                        <h4>Navigation</h4>
                        <ul>
                            <li><router-link to="/environmental-impact/">Environmental Impact</router-link></li>
                            <li><router-link to="/about-us/">About Us</router-link></li>
                            <li><router-link to="/services/">Services</router-link></li>
                            <li><router-link to="/testimonials/">Testimonials</router-link></li>
                            <li><router-link to="/contact-us/">Contact Us</router-link></li>
                            <li><router-link to="/terms-and-conditions/">Terms &amp; Conditions</router-link></li>
                            <li><router-link to="/privacy-policy/">Privacy Policy</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 footer-copy">
                <p>Copyright &copy; Spectrum Digital Labels. All Rights Reserved {{ new Date().getFullYear() }}.</p>
                <a class="netmatters" href="https://www.netmatters.co.uk/" target="_blank" rel="noopener">Website design by Netmatters</a>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'main-footer'
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/partials/MainFooter.vue